import { useEffect } from 'react';
import { RegionTypes } from '../../../config/regions';
import { buildLocalizeRoute } from '../../../helpers/languageHelper';
import { useNavigate } from 'react-router-dom';

export const RegionHandler = () => {
	let currentRegion = localStorage.getItem('region') || RegionTypes.Global;
	const navigate = useNavigate();
	useEffect(() => {
		navigate(buildLocalizeRoute('', currentRegion));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);


	return null;
};

export default RegionHandler;
